import Footer from "../../components/Footer/Footer"
import Navbar1 from "../../components/Navbar1/Navbar1"
import PrivacyPolicyPage from "./PrivacyPolicyPage"
import React from 'react'

const PrivacyPolicy = () => {
  return (
<div>
<Navbar1/>
   <PrivacyPolicyPage/>
   <Footer/> 
</div>
  )
}
export default PrivacyPolicy